export default "a-default";



// WEBPACK FOOTER //
// ./src/mod.js